// extracted by mini-css-extract-plugin
export default {"id":"IdPlace_id__eiEL6"};